module.exports = __webpack_public_path__ + "img/Categories_bg_11.96c6e452.jpg";